<template>
  <div class="width-100">
    <h1 v-if="!isEditing" @click="$emit('start-editing')">{{ title }}</h1>

    <textarea
        v-else
        v-model="localTitle"
        class="title-textarea"
        placeholder="Enter title here"
        rows="1"
        @input="autoResize"
    />
    <button v-if="isEditing" @click="updateTitle" class="action-button update">Update</button>
  </div>
</template>

<script>
export default {
  name: "ContentPageTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      localTitle: this.title,
    };
  },
  methods: {
    autoResize(event) {
      event.target.style.height = "auto";
      event.target.style.height = `${event.target.scrollHeight}px`;
    },
    updateTitle() {
      this.$emit("update:title", this.localTitle);
      this.isEditing = false;
    },
  },
};
</script>

<style>
.width-100 {
  flex: 1;
  min-width: 0; /* Важно для корректной работы flex */
}

.title-textarea {
  color: var(--my-white);
  font-weight: 600;
  border: none;
  border-bottom: 1px solid var(--my-border);
  outline: none;
  width: 100%;
  padding: 8px 0;
  background-color: transparent;
  resize: none;
  word-wrap: break-word;
  min-height: 40px;
}

h1 {
  margin: 0;
  padding: 8px 0;
  word-wrap: break-word;
  line-height: 1.2;
}

@media (max-width: 1560px) {
  .title-textarea {
    min-width: 60vh;
  }
}

@media (max-width: 1335px) {
  .title-textarea {
    min-width: 50vh;
  }
}

@media (max-width: 1155px) {
  .title-textarea {
    min-width: 40vh;
  }
}
</style>
